<template>
    <div class="content">
        <van-cell :title="'订单号:'+info.order_sn" >
            <template #right-icon>
                <span class="red">支付成功</span>
            </template>
        </van-cell>
        <van-card
            :title="info.goods_name"
            :thumb="info.photo_s"
           
            >
                <template #desc>
                    <p>保险期间：2020-5-11 00时至2021-5-10 24时</p>
                    <p>提交时间：{{info.create_time | timeType }}</p>
                    <p>投保计划：1年</p>
                    <p>被保险人：{{info.user_name}}</p>
                    <p>投保份数：1份</p>
                    <p>保费合计：￥{{info.amount}}</p>
                </template>
                <template #tags>
                <van-tag round class="tag red">{{info.company_simple_str}}</van-tag>
                </template>
                <template #footer >
                    <div class="priceLine">
                        <span>实付款: <span class="red">￥</span><span class="red price">{{info.pay_permium}}</span> </span>
                    </div>
                </template>
        </van-card>
        <van-cell title="" v-if="$store.state.userInfo.user_type!=1" class="border">
            <template #right-icon>
                <van-tag round class="footerTag bgcolor"   @click="detail()">查看保单</van-tag>
                <van-tag round plain class="red footerTag"  @click="addCard()">再次购买</van-tag>
            </template>
        </van-cell>
    </div>
 
</template>

<script>
import { Toast } from 'vant';
export default {
    props:["info"],
    methods:{
        detail(){
            // console.log("跳转到订单详情")
            this.$router.push({path:"/myOrderDetails"})
        },
        //再次购买
        addCard(){
            
            if(this.info.is_report==0){   //未报备
                this.$router.push("/productDetails?id="+this.info.id)
            }else if(this.info.is_report==1){  //已报备pjh
                this.$router.push("/productDetails?id="+this.info.id)
                // window.open(this.info.out_insure_url);
            }else{
                Toast("产品不存在")
            }
        },
    },
    filters:{
        timeType(time){
            var date=new Date(time*1000);
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var day = date.getDate();
            var h=date.getHours();
            var m=date.getMinutes();
            var s=date.getSeconds();
            month= month<10 ? "0"+month : month;
            day= day<10 ? "0"+day : day;
            h= h<10 ? "0"+h : h;
            m= m<10 ? "0"+m : m;
            s= s<10 ? "0"+s : s;
            var nowDate = year + "-" + month + "-" + day+" "+h+ ":" +m+ ":" +s;
            return nowDate
        }
    },
}
</script>

<style scoped>
    p{
        margin: 4px 0;
    }
    .content{
        text-align: start;
        box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.14);
        border-radius: 6px;
        margin:12px;
        padding:05px 10px 0 10px;
        background: rgba(255,255,255,1);
    }
    .van-cell {
        font-size: 13px;
        padding: 10px 0;
    }
    .van-card{  
        padding: 0;
        color:#666666;
        font-size: 12px;
    }
    .van-card__title{
        font-weight: 800;
        color: #333;
        font-size: 14px;
    }
    .van-card__thumb{
        width: 80px;
        height: 80px;
        margin-right:15px;
    }
    .van-card__content{
        padding-top: 2px;
    }
    .van-card__thumb /deep/ img{
        width:80px;
        height:80px;
        border-radius: 4px;
    }
    .van-card__bottom{
        line-height: 14px;
    }
    .desc{
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        /* autoprefixer: on */
        -webkit-line-clamp: 2;  
        /*! autoprefixer: off */
        -webkit-box-orient: vertical;
        margin:0;
    }
    .tag{
        background: rgba(243,71,64,0.1);
        font-size:10px;
    }
    /* .van-card__footer,.desc{
        font-size: 14px;
        color: rgba(102,102,102,1);

    } */
    .price{
        font-size: 18px;
    }
    .footerTag{
        font-size: 13px;
         margin-left: 10px;
        width: 75px;
        height: 30px;
        display: flex;
        justify-content: center;
    }
    .bgcolor{
        background: linear-gradient(left,#f34740, #fe8e89);
    }
    .priceLine{
        height: 40px;
        line-height: 40px;
        
    }
    .border{
        border-top: 1px solid #ddd;
    }
    .van-card{
        background: #fff;
    }
    .van-cell:not(:last-child)::after{
        border: 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/cellOrder.vue